module.exports = __webpack_public_path__ + "static/gm-17-f20a5733b962e0f0cbfffbdb8fef2b36.jpg";